<ion-button
  [disabled]="loading || disabled"
  class="usf-outline-green-button"
  (click)="emitDownload()"
  [ngClass]="{
    'tablet':
      (platformService?.isTouchExperience$ | async) &&
      platformService?.platformType === platformService?.platformEnum?.tablet,
    'mobile':
      (platformService?.isTouchExperience$ | async) &&
      platformService?.platformType !== platformService?.platformEnum?.tablet,
    'desktop': (platformService?.isTouchExperience$ | async) === false,
    'is-loading': loading,
  }"
>
  <div class="csv-button-label">
    <span *ngIf="!showTimeMessage">{{ buttonLabel }}</span>
    <p *ngIf="showTimeMessage" class="time-message">
      This might take a moment...
    </p>
    <ion-icon *ngIf="!loading" name="download-outline" slot="end"></ion-icon>
    <ion-spinner
      *ngIf="loading"
      name="circles"
      data-cy="loading-spinner-icon"
    ></ion-spinner>
  </div>
</ion-button>
